import axios from "axios";
import config from "app/api/axiosConfig";

export default (id: string, albumId: string, token: string) =>
	axios.delete(`${process.env.REACT_APP_GALLERY_HOST}/gallery/albums/${albumId}/resources/${id}`, config(token))
